// extracted by mini-css-extract-plugin
export default {"svg":"svg_svg__ggVUt","svgWrapper":"svg_svgWrapper__OI8EB"};